// extracted by mini-css-extract-plugin
module.exports = {"branding-image":"Step8_branding-image__2cEaX"};